export const setWpdata = (state,data) => {
  state.wpdata = data;
}

export const fetchFail = (error) => {
  console.log(error);
}

export const setAnalyseOption = (state,data) => {
  state.selections.selected_analyse = data;
}

export const setCameraOption = (state,data) => {
  state.available = data.shop_camera_options_available;
  if(state.available === false) {
    state.delivery_type = 'date';
    state.delivery_date = data.shop_camera_options_available_from;
    state.delivery_date_min = data.shop_camera_options_available_from;
    let maxDate = new Date(state.delivery_date_min);
    let deliveryDateFrom = new Date(state.delivery_date);
    let currentDate = new Date();

    if(deliveryDateFrom < currentDate) {
      currentDate.setDate( currentDate.getDate() + 14 );
      state.delivery_date_min = currentDate.toISOString().slice(0, 10);
    }
    if(maxDate > currentDate){
      maxDate.setMonth( maxDate.getMonth() + 6 );
      state.delivery_date_max = maxDate.toISOString().slice(0, 10);
    }else{
      currentDate.setMonth( currentDate.getMonth() + 6 );
      state.delivery_date_max = currentDate.toISOString().slice(0, 10);
    }
  } else {
    state.delivery_type = 'now';
    let currentDate = new Date();
    currentDate.setDate( currentDate.getDate() + 14 );
    state.delivery_date_min = currentDate.toISOString().slice(0, 10);
    currentDate.setMonth( currentDate.getMonth() + 6 );
    state.delivery_date_max = currentDate.toISOString().slice(0, 10);
  }
  state.selections.selected_camera = data;
}

export const setFullPriceData = (state) => {
  state.values = {
    price_streaming: parseFloat(state.wpdata[wpGlobalData.language].streaming[0].shop_streaming_price),
    price_analyse: parseFloat(state.selections.selected_analyse.shop_analyse_options_price),
    price_camera: parseFloat(state.selections.selected_camera.shop_camera_options_price),
    term_discount: parseFloat(state.wpdata[wpGlobalData.language].general[0].shop_general_laufzeit[0].shop_general_laufzeit_discount),
    term_month: parseFloat(state.wpdata[wpGlobalData.language].general[0].shop_general_laufzeit[0].shop_general_laufzeit_month),
    payment_discount: parseFloat(state.wpdata[wpGlobalData.language].general[0].shop_general_payment[0].shop_general_payment_discount),
    payment_type: state.wpdata[wpGlobalData.language].general[0].shop_general_payment[0].shop_general_payment_type,
    payment_type_name: state.wpdata[wpGlobalData.language].translations.slang_payment[0].slang_payment_monthly
  }
}

export const updateValue = (state, { key, value }) => {
  state.addressForm[key] = value
}

export const setDeliveryType = (state,data) => {
  state.delivery_type = data;
}

export const setDeliveryDate = (state,data) => {
  state.delivery_date = data;
}

export const setDeliveryMinDate = (state,data) => {
  state.delivery_date_min = data;
}

export const setDeliveryMaxDate = (state,data) => {
  state.delivery_date_max = data;
}

export const toggleOffer = (state) => {
  state.showOffer = !state.showOffer;
}



// WEBPACK FOOTER //
// ./src/store/mutations.js